import styled from 'styled-components';
import { motion } from 'framer-motion';

export const Wrapper = styled(motion.section)`
  position: relative;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  color: var(--color-text-light);
  background: var(--color-primary);
  z-index: 2;

  @media (${({ theme }) => theme.respondTo.desktop}) {
    flex-direction: row;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    width: 100%;
    overflow: auto;
    z-index: 0;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const LeftColumn = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80vh;
  max-height: 57rem;
  flex-direction: column;
  width: 100%;
  font-family: var(--font-secondary);

  @media (${({ theme }) => theme.respondTo.desktop}) {
    position: sticky;
    top: 0;
    height: 100vh;
    max-height: none;
    flex: 0 0 50%;
    width: 50%;
    z-index: 1;
  }

  .image-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
`;

export const MainTitle = styled.h1`
  font-weight: var(--font-weight-regular);
  font-size: 7rem;
  position: absolute;

  @media (${({ theme }) => theme.respondTo.desktop}) {
    font-size: 11rem;
    padding: 0 2rem;
  }
`;

export const CtaContainer = styled.div`
  margin-top: 30rem;
  font-family: var(--font-primary);
  font-size: 1.7rem;
  .normal-btn {
    border-bottom-right-radius: 0;
    padding: 1.9rem 3rem 1.8rem;
  }
  .reversed-btn {
    border-top-left-radius: 0;
    padding: 1.9rem 3rem 1.8rem;
  }

  @media (${({ theme }) => theme.respondTo.desktop}) {
    margin-top: 75%;
  }
`;

export const AndSign = styled.div`
  align-items: center;
  justify-content: center;
  background-color: var(--color-white);
  color: var(--color-primary);
  font-size: 4.8rem;
  border-radius: 50%;
  transform: translate(0, -50%);
  display: flex;
  position: absolute;
  top: 100%;
  width: 8rem;
  height: 8rem;

  @media (${({ theme }) => theme.respondTo.desktop}) {
    font-size: 7rem;
    left: 50vw;
    width: 12.8rem;
    height: 12.8rem;
    top: unset;
    transform: translate(-50%, 0);
  }
`;

export const RightColumn = styled(motion.div)`
  position: relative;
  flex: 1;
  padding: 7rem 3rem 0;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0 5rem;
  }
  @media (${({ theme }) => theme.respondTo.desktop}) {
    display: block;
    gap: 0;
    padding: ${({ firstCardDistanceFromTop }) => `${firstCardDistanceFromTop}px 5vw 0`};
  }
`;

export const BackgroundOverlay = styled(motion.div)`
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: black;
  pointer-events: none;
  opacity: 0;
  z-index: 1;
  + .content {
    margin-top: -3rem;
  }

  @media (${({ theme }) => theme.respondTo.desktop}) {
    display: block;

    + .content {
      margin-top: 100vh;
    }
  }
`;
